import { ReactElement, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import MaterialCard from '../../../../../../../common/material-card/material-card';
import PriceWithCurrency from '../../../../../../../common/price-with-currency/price-with-currency';
import cn from '../../../../../../../utils/classnames';
import isSaleAllowed from '../../../../../../../utils/material/is-sale-allowed';
import formatPrice from '../../../../../../../utils/price/format-price';
import SaveLabel from '../save-label/save-label';
import './bundle-material-card.scss';

type BundleMaterialCardProps = { material: Material; children?: ReactNode; className?: string; itemIndex?: number };

const BundleMaterialCard = (props: BundleMaterialCardProps): ReactElement => {
    const { material, children, className, itemIndex } = props;

    const { countryCode } = useSelector((state: RootState) => state.main.geotargeting);

    const internalPath = 'mp_bundle';

    const saleAllowed = isSaleAllowed(material, countryCode);
    const savings = saleAllowed ? (material?.sale?.original_price ?? 0) - (material?.sale?.sale_price ?? 0) : 0;
    const packetSavings = material.bundleMaterialsPrice - Number(material.price);

    const shouldShowPacketSavings = savings <= 0 && packetSavings > 0;
    const savingsToShow = shouldShowPacketSavings ? packetSavings : savings;
    const oldPriceToShow = shouldShowPacketSavings ? material.bundleMaterialsPrice : undefined;

    const cardClassNames = cn('mp-bundle-material-card', className);

    return (
        <MaterialCard material={material} internalPath={internalPath} itemIndex={itemIndex} className={cardClassNames}>
            <PriceWithCurrency item={material} oldPrice={oldPriceToShow} />

            {savingsToShow > 0 && <SaveLabel saveAmount={formatPrice(savingsToShow)} />}

            {children}
        </MaterialCard>
    );
};

export default BundleMaterialCard;
